import { Box, Grid, Tab } from "@material-ui/core";
import { TabContext, TabList } from "@material-ui/lab";
import useCustomState from "../../hooks/State";
import {
  BarChart,
  Dashboard,
  Info,
  PeopleAlt,
  Settings,
  Speed,
  Vibration,
} from "@material-ui/icons";
import NoData from "../BillsFilter/NotFound";
import ProjectAbstract from "./ProjectAbstract";
import ProjectCharts from "./ProjectCharts";
import ProjectCounters from "./ProjectCounters";
import ProjectDetails from "./ProjectDetails";
import ProjectBuyers from "./ProjectBuyers";
import ProjectSettings from "./ProjectSettings";
import ListDevices from "../projectDetails/ListDevices";

const ProjectDashboard = ({
  projectId,
  project,
  devices,
  tags,
  types,
  sortValue,
  reverseValue,
  counterTab,
  changeCounterTab,
  count,
  gasPage,
  powerPage,
  waterPage,
  updateCounterTable,
  changeCounterPage,
  consumptions,
  tableLoading,
  TabValue,
  changeTab,
}) => {
  const iconStyle = { marginLeft: "7px", fontFamily: "Vazir" };

  const renderTabContext = (tabValue) => {
    switch (tabValue) {
      case "0":
        return (
          <ProjectAbstract
            project={project.value}
            devices={devices.value}
            tags={tags}
            types={types}
          />
        );
      case "1":
        return <ProjectCharts project={project.value} />;
      case "2":
        return <ProjectDetails project={project.value} />;
      case "3":
        return (
          <ProjectCounters
            projectId={projectId}
            devices={devices.value}
            sort={sortValue}
            reverse={reverseValue}
            counterTab={counterTab}
            projectTab={TabValue}
            changeCounterTab={changeCounterTab}
            dataCount={count}
            gasPage={gasPage}
            powerPage={powerPage}
            waterPage={waterPage}
            updateTable={updateCounterTable}
            changePage={changeCounterPage}
            consumptions={consumptions}
            tableLoading={tableLoading}
          />
        );
      case "4":
        return <ListDevices devices={devices.value} types={types} />;

      case "5":
        return <ProjectBuyers devices={devices.value} />;
      case "6":
        return (
          <ProjectSettings
            project={project.value}
            devices={devices.value}
            tags={tags}
            types={types}
          />
        );
      default:
        return <NoData message={"در بارگزاری این منو مشکلی پیش آمده"} />;
    }
  };
  return (
    <>
      <Grid
        container
        style={{ padding: "5px 16px" }}
        className="live-device-tabs"
      >
        <Box
          sx={{
            width: "100%",
            typography: "body1",
            background: "white",
          }}
          style={{
            boxShadow: "0 1px 1px 0 #999",
            borderRadius: "5px",
          }}
        >
          <TabContext value={TabValue}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Grid container xs={12} sm={12} md={12} lg={12}>
                <TabList
                  onChange={changeTab}
                  variant="scrollable"
                  scrollButtons="auto"
                  textColor="secondary"
                  indicatorColor="secondary"
                >
                  <Tab
                    icon={<Dashboard style={iconStyle} />}
                    iconPosition="start"
                    label="داشبورد"
                    value="0"
                  />
                  <Tab
                    icon={<BarChart style={iconStyle} />}
                    iconPosition="start"
                    label="نمودار مصرف"
                    value="1"
                  />
                  <Tab
                    icon={<Info style={iconStyle} />}
                    iconPosition="start"
                    label="جزئیات"
                    value="2"
                  />
                  <Tab
                    icon={<Speed style={iconStyle} />}
                    iconPosition="start"
                    label="کنتور ها"
                    value="3"
                  />
                  <Tab
                    icon={<Vibration style={iconStyle} />}
                    iconPosition="start"
                    label="سایر دستگاه ها"
                    value="4"
                  />
                  <Tab
                    icon={<PeopleAlt style={iconStyle} />}
                    iconPosition="start"
                    label="خریداران"
                    value="5"
                  />
                  <Tab
                    icon={<Settings style={iconStyle} />}
                    iconPosition="start"
                    label="تنظیمات"
                    value="6"
                  />
                </TabList>
              </Grid>
            </Box>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Grid
                container
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{
                  borderRadius: " 0 0 8px 8px",
                  boxShadow: "0px 2px 2px 0px #444",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                }}
              >
                {renderTabContext(TabValue)}
              </Grid>
            </Box>
          </TabContext>
        </Box>
      </Grid>
    </>
  );
};
export default ProjectDashboard;
